// src/rtkQuery/features/services/cartDrawer/cartDrawerSlice.ts

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isCartOpen: false, 
  itemQuantities: {} as Record<number, number>,
};

const cartDrawerSlice = createSlice({
  name: "cartDrawer",
  initialState,
  reducers: {
    toggleCart: (state) => {
      state.isCartOpen = !state.isCartOpen;
    },
  },
});

export const { toggleCart } =
  cartDrawerSlice.actions;
export default cartDrawerSlice.reducer;